import { createGlobalStyle } from "styled-components"
import { normalize } from 'styled-normalize'
import reset from 'styled-reset-advanced'

import variables from "../styles/variables"

const GlobalStyle = createGlobalStyle`
  ${normalize}
  ${reset}

  html {
    background-color: ${variables.colors.bottleGreen};
  }

  a {
    text-decoration: underline;
  }

  body {
    text-rendering: optimizeLegibility;
    background-color: ${variables.colors.bottleGreen};
  }
`

export default GlobalStyle
